import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import React from "react";
interface MultiSelectProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: MultiSelectState;
    settings: any;
}

export class KendoMultiSelect extends React.Component<MultiSelectProps, any>{
    private multiSelect;
    private multiSelectRef;
    private parentCompsValues = {};
    private multiSelectStateWrapper: MultiSelectState;

    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.multiSelectStateWrapper = new MultiSelectState();
        this.multiSelectStateWrapper.hydrateFromJS(props.settings);
    }

    getData = (params) => {
        var that = this;
        if (this.props.settings.dataUrl) {
            this.setState({ isLoading: true });
            utility.httpService.get(this.props.settings.dataUrl, params, function (data) {
                that.setState({ values: data, isLoading: false });
            });
        }
    }

    componentDidMount() {
        var that = this;
        var $rootNode = $(this.multiSelectRef);

        var select = $rootNode.kendoMultiSelect({
            filter: "contains",
            dataTextField: this.props.settings.valueField,
            dataValueField: this.props.settings.keyField,
            placeholder: "...",
            change: function () {
                var value = this.value();
                that.props.onTextChange(that.props.settings.name, value);
            }
        });
        this.multiSelect = select.data("kendoMultiSelect");
        this.getData({});
    }

    handleClearSelection = () => {
        if (this.multiSelect) {
            this.props.onTextChange(this.props.settings.name, []);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.multiSelectStateWrapper.hydrateFromJS(this.props.settings);

        var value = this.props.values ? this.props.values[this.props.settings.name] : null;

        if (this.state.values !== prevState.values && this.state.values) {
            this.multiSelect.dataSource.data(this.state.values);
        }

        if (JSON.stringify(value) != JSON.stringify(this.multiSelect.value())) {
            if (Array.isArray(value)) {
                this.multiSelect.value(value);
            }
            else {
                this.multiSelect.value([value]);
            }
        }
        if (this.props.settings.dataUrl !== prevProps.settings.dataUrl) {
            this.getData({});
        }

        const parentComps = this.multiSelectStateWrapper.parentComponents;
        if (parentComps && parentComps.length > 0) {
            if (JSON.stringify(value) != JSON.stringify(this.multiSelect.value())) {
                this.props.onTextChange(this.props.settings.name, this.multiSelect.value());
            }
            let newParentValues = {};
            for (let i = 0; i < parentComps.length; i++) {
                newParentValues[parentComps[i].componentName] = this.props.values[parentComps[i].componentName];
            }
            if (JSON.stringify(this.parentCompsValues) != JSON.stringify(newParentValues)) {
                this.parentCompsValues = newParentValues;
                this.getData(this.parentCompsValues);
            }
        }
    }

    render() {
        const values = this.props.values ? this.props.values[this.props.settings.name] : null;
        const disabled = (values && values.length > 0) ? false : true;
        if (this.state.isLoading) {
            var spinner = <img src={this.props.context.variables["INNO_BASE_PATH"] + "Statistics/Content/img/spinner.gif"} />
        }
        return (<react_components.ReactColumn width={this.props.metadataSettings.width}>
            <ErrorBoundary>
                <div className="form-group">
                    <react_components.TruncatedLabel>{this.props.settings.label}</react_components.TruncatedLabel> {spinner}
                    <div>
                        <select ref={(multi) => this.multiSelectRef = multi} />
                    </div>
                </div>
            </ErrorBoundary>
        </react_components.ReactColumn>)
    }
};

export class MultiSelectState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private dataUrlMetadata = new propertyTypes.ServiceSelectorProperty("dataUrl", "Data url", false, propertyTypes.DataSourceType.sql)
    public dataUrl: string;

    private keyFieldMetadata = new propertyTypes.ColumnProperty("keyField", "Key", "dataUrl");
    public keyField: string;

    private valueFieldMetadata = new propertyTypes.ColumnProperty("valueField", "Value", "dataUrl");
    public valueField: string;

    private parentComponentsMetadata = new propertyTypes.ObjectListPropertyExt("parentComponents", "Parent components").addStateImplementation("default", ParentComponent)
    public parentComponents: ParentComponent[];

    private isMandatoryMetadata = new propertyTypes.CheckBoxProperty("isMandatory", "Is mandatory?");
    public isMandatory: string;

    private selectMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.getNameMetadata().SetMandatory(true);
        const baseMetaData = super.getMetadata();
        this.selectMetadataAll = baseMetaData.concat([this.labelMetadata, this.dataUrlMetadata, this.keyFieldMetadata, this.valueFieldMetadata, this.isMandatoryMetadata, this.parentComponentsMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.selectMetadataAll;
    }
}

class ParentComponent extends propertyTypes.Serializable {
    private componentNameMetadata = new propertyTypes.TextProperty("componentName", "Component name", true);
    public componentName: string;

    private parentComponentMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.parentComponentMetadata = [this.componentNameMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.parentComponentMetadata;
    }
}
